import { BaseModel } from '../../_base/crud';

export class Immunization extends BaseModel {
  id: number;
  status;
  statusReason;
  vaccine;
  occurrence;
  recordedDate;
  primarySource;
  reportOrigin;
  lotNumber;
  expirationDate;
  site;
  route;
  function;
  actorType;
  actor;
  note;
  series;
  reasonCode;
  isSubpotent;
  subpotentReason;
  documentType;
  reference;
  presentationDate;
  publicationDate;
  programEligibility;
  fundingSource;
  targetDisease;
  doseNumber;
  seriesDoses;
  doseQuantityUnit;
  doseQuantityValue;
  recorded;
  vaccineCode;
  protocolApplied;
  doseQuantity;
  education;
  performer;
  reasonReference;
  condition;

  clear(): void {
    this.id = 0;
    this.status = null;
    this.statusReason = null;
    this.vaccine = null;
    this.occurrence = null;
    this.recordedDate = null;
    this.recorded = null;
    this.primarySource = null;
    this.reportOrigin = null;
    this.lotNumber = null;
    this.expirationDate = null;
    this.site = null;
    this.route = null;
    this.function = null;
    this.actorType = null;
    this.actor = null;
    this.note = null;
    this.reasonCode = null;
    this.isSubpotent = null;
    this.subpotentReason = null;
    this.documentType = null;
    this.reference = null;
    this.presentationDate = null;
    this.publicationDate = null;
    this.programEligibility = null;
    this.fundingSource = null;
    this.targetDisease = null;
    this.doseNumber = null;
    this.seriesDoses = null;
    this.series = null;
    this.doseQuantityUnit = null;
    this.doseQuantityValue = null;
    this.vaccineCode = null;
  }
}
